import Vue from 'vue';
import Vuex from 'vuex';
import cart from './modules/cart';

// this is a hack because node 8 doesnt link to build vue
// const process = null;
Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    cart,
  },
});